import { createModel } from "hox";
import React, { Key, useState } from "react";
import StoreService from "./StoreService";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdStoreDetail, IMdStoreFields } from "./StoreTypes";
import { orgService } from "../org/OrgService";
import { TreeDsType } from "@src/components/YhPageHeader/Types";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}


function StoreModel() {

    const initSearchParam: IMdStoreFields = {};
    const initDataSource: IMdStoreDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdStoreFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdStoreDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [resetState, setResetState] = useState(false)

    const [orgDs, setOrgDs] = useState<TreeDsType[]>()

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }

    /**
         * 加载选择项
         */
    const loadDs = async () => {
        let orgds = await orgService.orgTreeDs({})
        // let beds = await dictService.dictItemDs('address')
        setOrgDs(orgds)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdStoreFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    const loadData = async (page?: ISearchPage, searchValue: IMdStoreFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await StoreService.finPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        records.forEach(item => {
            if (!item.key) {
                item.key = item.id as Key
            }
        })
        setDataSource(records);
    }

    const syncData = async () => {
        let ret = await StoreService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData()
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        resetState,
        orgDs,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        getSelectedRowData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        syncData,
        onSearch,
        onReset,
        loadDs,
    }

}


export const useStoreModel = createModel(StoreModel);